import React, { useEffect, useState } from "react";
import { AsyncAjaxGet, AsyncAjaxPost } from "../Utilities/AsyncAjaxService";
import { UserContext } from "../Definitions/UserContext";
import { error } from "jquery";
import { json } from "express";

export default function SubscriptionThankyou({userContext}:{userContext:UserContext}) {

const [hasSubbed,setHasSubbed] = React.useState(false);
const [hasErrored,setHasErrored] = React.useState(false);
const [promoCode,setPromoCode] = React.useState("");
const [copied,setCopied] = React.useState(false);
    

    useEffect(() => {


      let pathSplit = window.location.pathname.split("/");

      let subId = pathSplit.pop();
      let merchantId = pathSplit.pop();

      if(!userContext||!subId||!merchantId){
        setHasErrored(true);
        return;
      }
 
      AsyncAjaxPost(
        "merchants/subscription/subscribe",
        JSON.stringify({Id:subId}),
        userContext.accessToken,
        (data:any)=>{

          if(data?.data?.data?.promotionCode){
            setPromoCode(data?.data?.data?.promotionCode);
          }
          setTimeout(()=>setHasSubbed(true)
          ,500) // let the spinner show for half a second
        },
        (err:any)=>{
          setHasErrored(true);
        },merchantId
      )

    }, []);



  if(hasErrored){


    return     <div className="flex flex-column center-all w-full gap-large" style={{height:"70vh",padding:"32px",textAlign:"center"}}>

      <h1>Oops! Something went wrong, try freshing this page or re-clicking the link from your email.</h1>
    </div>
  }


  return (
    <div className="flex flex-column center-all w-full gap-med" style={{height:"70vh"}}>
     {hasSubbed? <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{opacity:"0"}}   height="3em" fill="currentColor"className="vanimation-grow"><path d="M64 96H448c17.7 0 32 14.3 32 32v32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H360.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V207.6L208.7 337.1c28.2 20.6 66.5 20.6 94.6 0l17.1-12.5c1-16.2 4.3-31.8 9.4-46.6l-45.4 33.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32zM496 224a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 353.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"/></svg>
        <h1 className="vanimation-fade-in text-align-center no-delay" style={{opacity:"0",marginBottom:"8px"}}>Thanks for Subscribing!</h1>
        <div className="vanimation-fade-in" style={{opacity:"0"}} >{"We'll send you the latest deals and news!" }</div>
        {promoCode?
        <> 
          <div className="vanimation-fade-in" style={{opacity:"0"}} >{"Apply this promo code at checkout for a discount." }</div>
          <div className="vanimation-fade-in" 
          
          onClick={(e)=>{
            window.navigator.clipboard.writeText(promoCode);
            setCopied(true);
          }}
          style={{opacity:"0",animationDelay:".4s",fontWeight:"bold",fontSize:"20px",cursor:"pointer"}} >{promoCode}</div>
          {copied&&
          <div className="" style={{opacity:".7",fontSize:"11px",height:"8px", marginTop:"-14px",marginBottom:"-2px"}} >Copied to clipboard</div>
          }
          <div></div>
        </>:
        <br />
        }
        
        <a href="./" className="v-button primary vanimation-fade-in-up"  style={{opacity:"0",background:"lightgrey"}} >Go Home</a>
    
      </>:<>

      <style>
        {`
        @keyframes flip-around {
  
          0%{
            transform:rotatey(0);
          }
         
          100%{
            transform:rotatey(360deg);
          }
          
        }

        #sub-loader{
          animation: flip-around 1s infinite ease-in-out;
          transform-origin: center;
          perspective:300px;
        }
        `
        }
      </style>
      <div style={{perspective:"300px"}}>
      <div id='sub-loader'>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  height="5em" fill="currentColor"><path d="M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"/></svg>
      </div>
      </div>
      </>}
    </div>
  );
  
}